import { Component } from '@angular/core';
import { transitionAnimation } from '../../../scss/themes/animation';
import { MainNavComponent } from '../../shared/components/main-nav/main-nav.component';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';



@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  imports: [
    MainNavComponent,
    NgOptimizedImage,
    TranslateModule
  ],
  animations: [transitionAnimation]
})
export class NotFoundComponent {
    constructor() { }
}
